import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import "./HeaderSearch.css"
import CloseIcon from '@mui/icons-material/Close';
import { APIUrlEICI, APIUrlToken } from '../../Utils/Utils';
import axios from 'axios';
import CalenderModals from '../Modals/Index';
import { useNavigate } from 'react-router-dom';
export default function HeaderSearch({ loading, setLoading }) {
  const [showSearchdata, setshowSearchdata] = React.useState(false);
  const [headerSearchData, setheaderSearchData] = React.useState("");
  const [responseData, setResponseData] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState([])
  const [showSelectedData, setShowSelectedData] = React.useState(false)
  const navigate = useNavigate();

  const handleClose = () => {
    setShowSelectedData(false)
    setSelectedData()
  }
  const handelselectdata = (item) => {
    setSelectedData(item)
    setShowSelectedData(true)
  };
  const emtySearchdata = () => {
    setheaderSearchData("")
  }
  const handlesearch = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "Authorization": APIUrlToken()
      },
      url: `${APIUrlEICI()}/search_event?search=${headerSearchData?.trim()}`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setshowSearchdata(true);
        setResponseData(response?.data);

      })
      .catch((error) => {
        setLoading(false);
        setshowSearchdata(true);
        setResponseData([]);
      });
  };
  React.useEffect(() => {
    let timer;
    if (headerSearchData?.length > 2) {
      timer = setTimeout(() => {
        handlesearch();
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [headerSearchData]);
  React.useEffect(() => {
    const handleClick = () => {
      setshowSearchdata(false);
      setheaderSearchData("");
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (headerSearchData && responseData) {
        navigate("/searchInfo", {
          state: { query: headerSearchData, results: responseData },
        });
      } else {
        console.error("Invalid data: headerSearchData or responseData is undefined or null");
      }
    }
  };


  return (
    <>
      <Paper className='full-searchbar'
        component="form"
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
      >
        <SearchIcon className='searchicon-in-header' />
        <InputBase
          value={headerSearchData}
          onKeyDown={handleKeyDown}
          onChange={(e) => {
            const inputValue = e.target.value; 
            setheaderSearchData(inputValue);
          }} className='search-inner-text'
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search..."
          inputProps={{ 'aria-label': 'Search google maps' }}
          autoComplete="off"
        />
        <div onClick={emtySearchdata} className='cross-icon-prospect-search'>
          {headerSearchData && (
            <CloseIcon className='showicons-search' />
          )}            </div>
        {showSearchdata && (
          <div className={'Autocompletedropdown'}>
            {responseData?.length > 0 ? (
              responseData.map((item) => (
                <>
                  <div className='outterAutocompletedropdown' key={item.event_id} onClick={() => handelselectdata(item)} >
                    <div className='useralldata'>
                      {item?.primary_attendees
                        ?.map(
                          (i) =>
                            i?.attendee_name
                        )
                        .join(", ")}
                      <span className='nodal_span_evnt'>
                        {
                          item?.categories
                            .map(
                              (i) =>
                                i
                            )
                            .join(", ")
                        }
                      </span>
                    </div>
                    <div className='useralldata2'>
                      {item?.subject}
                    </div>
                    <div className='separatorline'></div>

                  </div>

                </>
              ))
            ) : (
              <div className='useralldata'>Not Available</div>
            )}
          </div>
        )}
      </Paper>
      <CalenderModals open={showSelectedData} onClose={handleClose} event={selectedData} />
    </>
  );
}